import Calendar from 'v-calendar/lib/components/calendar.umd';
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import Vue from 'vue';

// Register components in your 'main.js'
Vue.component('calendar-display', Calendar);
Vue.component('calender-date-picker', DatePicker);
